import { useState, useEffect } from "react";
import { Typography, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function FiltersCom(props) {
  const [selectState, setSelectState] = useState();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setSelectState(props.orderFilter);
  }, [props.orderFilter]);

  const [state, setState] = useState([
    {
      id: 0,
      name: "همه",
    },
    {
      id: 1,
      name: " پیک موتوری",
    },
    {
      id: 2,
      name: "پست",
    },
    {
      id: 7,
      name: "اکسپرس",
    },

    {
      id: 3,
      name: "نقدی",
    },
    {
      id: 4,
      name: "آنلاین",
    },
    {
      id: 5,
      name: "آفلاین",
    },
    {
      id: 8,
      name: "اقساطی",
    },
    {
      id: 6,
      name: "انتظار",
    },
  ]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: isSmall ? "flex-start" : "center",
        flexDirection: isSmall ? "column" : "row",
        mt: 2,
      }}
    >
      <Typography variant="subtitle2">فیلتر :</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 1,
        }}
        spacing={1}
      >
        {state.map((model, i) => {
          return (
            <Box
              onClick={() => {
                props.setOrderFilter(model.id);
                props.setRefresh(true);
              }}
              color="primary"
              sx={{
                py: 0.5,
                px: 2,
                display: "flex",
                alignItems: "center",
                border: "1px",
                borderStyle: "solid",
                borderColor: "primary.main",
                borderRadius: "7px",
                width: "auto",
                cursor: "pointer",
              }}
              key={i}
            >
              {selectState !== undefined && model.id == selectState ? (
                <CheckIcon color="primary" fontSize="small" />
              ) : (
                <CheckIcon sx={{ display: "none" }} />
              )}
              <Typography variant="caption">{model.name}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
